module.exports = __webpack_public_path__ + "assets/img/zhgl.b056edb9.png";